import { useQuery } from 'react-query'

import { QueryKeys } from '../../../../../enums/queryKeys'
import { fetchUserOrganizations } from '../query-api'
import { UserOrganization } from '../types/Organizations'

interface UseFetchOrganizationsResponse {
  organizations: UserOrganization[]
  isLoading: boolean
}

export const useFetchOrganizations = (): UseFetchOrganizationsResponse => {
  const { data, isIdle, isLoading } = useQuery(QueryKeys.UserOrganizations, () => fetchUserOrganizations())

  return {
    organizations: data?.data || [],
    isLoading: isIdle || isLoading,
  }
}
